<template>
  <div class="news_wrap">
    <div class="news_tit">新聞資訊</div>
    <div class="carousel-wrapper">
      <el-carousel
        :interval="4000"
        :type="carouselType"
        height="300px"
        @change="handleCarouselChange"
      >
        <el-carousel-item v-for="(item, index) in coresList" :key="index">
          <div
            class="core_item_carousel"
            :class="item.isActive ? 'is_active' : ''"
            @click="changeCurrentIndex(index)"
          >
            <div class="content-wrapper">
              <h3 class="title">{{ item.tit }}</h3>
              <p class="description">{{ item.desc }}</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageWidth: window.innerWidth,
      coresList: [
        {
          tit:
            "EC研討會回顧 | 全南大學Seungwon Kim教授分享移情計算最新進展與未來方向",
          desc:
            "媒體報道和數據顯示，近五年三甲醫院晉升評審中，科研指標的權重已顯著提升。以某頂尖三甲醫院最新職稱晉升標準為例，科研指標（尤其是SCI論文）評分占比高達60%，而門診接診量及手術並發癥控製等臨床工作指標合計權重僅占20%",
          isActive: true
        },
        {
          tit: "論壇預告 | ACRT邀您參加第三屆全國生命健康研究生學術論壇",
          desc:
            "第三屆全國生命健康研究生學術論壇定於2025年11月7日至9日在深圳大學麗湖校區舉行。本論壇由深圳大學醫學部、中國細胞生物學學會及深圳市細胞生物學學會共同主辦，並聯合北京大學醫學部、清華大學基礎醫學院等21所高校協辦。",
          isActive: false
        },
        {
          tit:
            "EC研討會 | 奧克蘭大學Mark Billinghurst教授：移情計算：構建共享理解",
          desc:
            "2025年7月21日，Empathic Computing (EC)期刊成功舉辦了首場線上會議。本次活動由期刊編委Dr. Jean Botev主持，期刊主編、南澳大學與奧克蘭大學教授、新西蘭皇家學會院士 Mark Billinghurst 擔任主講嘉賓。會議聚焦於如何通過技術增強人際情感共鳴與遠程協作，吸引了全球多個國家的學者和技術從業者參與。",
          isActive: false
        },
        {
          tit:
            "ACRT人物專訪 | 深度對話蘇州大學邵常順教授——解碼衰老與腫瘤微環境",
          desc:
            "2025年10月29日，Ageing and Cancer Research & Treatment（ACRT）期刊編輯部有幸邀請到期刊編委、蘇州大學特聘教授、博士生導師邵常順教授進行深度專訪。在訪談中，邵教授回顧了多年的科研歷程，系統梳理了衰老與癌癥研究領域的關鍵突破。他不僅剖析了該領域面臨的前沿挑戰，也分享...",
          isActive: false
        },
        {
          tit: "CBM | 專訪電子科技大學林昊教授：談科研道路上的好奇、堅持與開放",
          desc:
            "近日，Computational Biomedicine（CBM）期刊編委，電子科技大學的林昊教授入選2025年全球Top 2%科學家榜單（由斯坦福大學發布），這一榮譽不僅體現了他在國際學術界的突出影響力，也彰顯了中國科研力量在計算生物學領域的崛起。",
          isActive: false
        }
      ],
      currentIndex: 0,
      newsList: [
        {
          newPlate: "行業幹貨",
          newHref:
            "http://gd.people.com.cn/BIG5/n2/2024/1206/c123932-41067825.html",
          imageSrc:
            "https://vep-tradeshow.hktdc.com/event/innoex/wp-content/uploads/sites/81/2024/04/image1-1.webp",
          newTitle: "粵港澳三地共同探索知識產權創新發展",
          newDetail:
            "12月5日，第14屆亞洲知識產權營商論壇在香港會議展覽中心舉辦。活動集論壇、展覽、比賽及商貿配對於一身，為初創及中小企業探索知識產權的潛力，掌握全球最新知識產權脈搏，發掘潛在投資者和生意夥伴提供平臺..."
        },
        {
          newPlate: "行業概況",
          newHref:
            "https://research.hktdc.com/tc/article/MzExMTM0MzQ0?ref_source=hkservices",
          imageSrc:
            "https://img.hktdc.com/eyJidWNrZXQiOiJjbXMtaW1nbGliLXByZCIsImtleSI6IlJNSVAvMjAyMDAyMTAveDFhNnh1b3MtUVZORlFVND0uanBlZyIsInJlZ2lvbiI6ImFwLXNvdXRoZWFzdC0xIiwiZm9ybWF0IjoianBlZyIsInF1YWxpdHkiOjEwMCwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjo4MDAsImhlaWdodCI6NDUwLCJmaXQiOiJjb3ZlciJ9fX0=",
          newTitle:
            "香港知識產權服務業概況 | 數據及概況 - 香港行業概況 - 服務行業",
          newDetail:
            "在香港，知識產權(IP)創造者、擁有者和使用者包括電影、電視節目、音樂和書籍出版等創意產業，科技界和工業設計界，以及大學和研發中心的知識轉移處等..."
        }
      ]
    };
  },
  computed: {
    carouselType() {
      return this.pageWidth > 1200 ? "card" : "";
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.pageWidth = window.innerWidth;
    },
    changeCurrentIndex(index) {
      // 在 methods 中的 changeCurrentIndex 方法裏替換原來的 push 語句
      this.$router
        .push({
          path: "/newsInfo",
          query: {
            index: index + 1
          }
        })
        .catch(err => {
          console.log("Navigation error:", err);
        });
    },
    handleCarouselChange(index) {
      this.currentIndex = index;
      this.coresList.map((v, i) => {
        i === index ? (v.isActive = true) : (v.isActive = false);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.news_wrap {
  width: 100%;
  margin-top: 50px;
  text-align: center;

  .news_tit {
    color: #203040;
    font-size: 2.5rem;
    font-weight: bold;

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
}

.carousel-wrapper {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0;

  @media screen and (max-width: 768px) {
    width: 100%;
  }

  :deep(.el-carousel) {
    .el-carousel__container {
      height: 400px;
      @media screen and (max-width: 768px) {
        margin-top: 58px;
      }
    }

    .el-carousel__item {
      border-radius: 8px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      &.is-active {
        .core_item_carousel {
          &.is_active {
            color: #fff;
            font-weight: bold;
            background: linear-gradient(
              134deg,
              #0649b8 1%,
              #0a7fd7 41%,
              #03d2c5 99%
            );
            box-shadow: 0 0.5rem 1.5rem 0 rgb(0 135 168 / 50%);
          }
        }
      }
    }
  }

  .core_item_carousel {
    width: 100%;
    height: 100%;
    border: solid 1px #04cac7;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px;
    box-sizing: border-box;

    @media screen and (max-width: 768px) {
      padding: 15px 10px;
    }

    .content-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .title {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
        line-height: 1.3;

        @media screen and (max-width: 768px) {
          font-size: 18px;
          margin-bottom: 15px;
        }
      }

      .description {
        font-size: 16px;
        line-height: 1.6;
        max-height: 200px;
        overflow-y: auto;

        @media screen and (max-width: 768px) {
          font-size: 14px;
          max-height: 150px;
        }
      }
    }

    &.is_active {
      color: #fff;
      font-weight: bold;
      background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
      box-shadow: 0 0.5rem 1.5rem 0 rgb(0 135 168 / 50%);

      .content-wrapper {
        .title,
        .description {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news_infomation/index.vue